import React, { useState, useEffect, useContext } from 'react';
import {Stack, Select} from '@shopify/polaris';
import {FormProvider, useFetch} from '@thinkwell/react.common';
import {EditModal, TextField, Checkbox, Autocomplete} from '@thinkwell/react.polaris';
import { CourseTreeContext } from '../contexts/CourseTree'

export default function EditContent(props) {
  const [courseTree, updateCourseTree] = useContext(CourseTreeContext)
  const item = props.item || {}

  const [type, setType] = useState(item.meta && item.meta.type)

  const onEditSave = (node) => {
    courseTree.updateNode(node)
    updateCourseTree(courseTree)
    props.onSave && props.onSave(node)
  }

  const onActive = (active) => {
    props.onActive && props.onActive(active)
  }

  const typeOptions = [
    {value: '', label: 'Select a type'},
    {value: 'Animation', label: 'Animation'},
    {value: 'Book', label: 'Book'},
    {value: 'BookRange', label: 'Book Range'},
    {value: 'Maple', label: 'Maple'},
    {value: 'Notes', label: 'Notes'},
    {value: 'Sample', label: 'Sample'},
    {value: 'SampleProblem', label: 'Sample Problem'},
    {value: 'SampleProblemCollection', label: 'Sample Problem Collection'},
    {value: 'VideoLecture', label: 'Video Lecture'},
    {value: 'WolframCdf', label: 'Wolfram CDF'},
    {value: 'PlainHtml', label: 'Plain HTML'},
    {value: 'CanvasQuiz', label: 'Canvas quiz'}
  ];

  let url;
  if (item.id) {
    url = `/nodes/${item.id}.json`
  } else {
    url = `/nodes.json?type=content`
  }

  return (
    <FormProvider data={{data: item}} rootName="node"><EditModal
      onSave={onEditSave}
      url={url}
      method={item.id ? 'put' : 'post'}
      linkText={props.linkText}
      title={props.title}>
      {
        !item.id ?
          <Select
            label="Content type"
            options={typeOptions}
            onChange={setType}
            value={type} /> : null
      }
      { type ?
        [<TextField required
          key="name"
          label="Node Name"
          name="name"
        />,
        <TextField
          key="book_content_id"
          label="Book Content Id"
          name="book_content_id"
        />,
        <Autocomplete
          key="content_id"
          name="content_id"
          label="Content"
          value={item.content_name}
          url={`${window.location.origin}/content.json?type=${type}`}
          valueProp="name"
        />,
        <table key="table" className="table-item"><tbody>
          { item.content_id ? <tr><th>Id</th><td>{item.content_id}</td></tr> : null }
          { type ? <tr><th>Type</th><td>{type}</td></tr> : null }
        </tbody></table>] : null
      }
    </EditModal></FormProvider>
  );
}
